import DrugBase from './drugBase'
class ReducedKidneyFunctionDrug extends DrugBase {
  constructor (id, name, substance, modifiedDate, modifiedByHsaId,
              modifiedByName, isPublished, nplId, fass,
              theRenalDrugHandbook, theKidney, theClinicalUseOfDrugs,
              drugdex, martindale, geriatricDosageHandbook, other) {
    super(modifiedDate, modifiedByHsaId, modifiedByName, isPublished)
    this.id = id
    this.name = name
    this.substance = substance
    this.nplId = nplId
    this.fass = fass
    this.theRenalDrugHandbook = theRenalDrugHandbook
    this.theKidney = theKidney
    this.theClinicalUseOfDrugs = theClinicalUseOfDrugs
    this.drugdex = drugdex
    this.martindale = martindale
    this.geriatricDosageHandbook = geriatricDosageHandbook
    this.other = other
  }
}

export default ReducedKidneyFunctionDrug
